import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import axios from "axios";
import { listUserGroups, defaultPagingChoices, emptyCellContent, userSubscriptionStatus } from "@/js/lists.ts";
import { request } from "@/js/http/http_request";
import { filterVAutocomplete } from "@/js/forms.js";
import { setFilters, getFilters } from "@/js/filter/filter.js";
import { getFullNameUser } from "@/js/user/user";
import pagingComponent from "@/components/paging/PagingComponent.vue";
import indexComponent from "@/components/paging/IndexComponent.vue";
import { getLoggedUserData, getUserLogged, hasRole, isAdminNotConsultant, isConsultantOrHolding, isHolding, isSalesman } from "../../js/http/auth.js";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import SubscriptionInvitationModal from "@/components/user/SubscriptionInvitationModal.vue";
import SendInvitationAsConsultantModal from "@/components/user/SendInvitationAsConsultantModal.vue";
var fileDownload = require("js-file-download");
export default {
  name: "adminUserListComponent",
  data: function data() {
    return {
      loggedUserData: {},
      currentUser: {},
      baseModel: {
        users: [],
        numberOfUsers: 0,
        numberOfPages: 0
      },
      datatable_loading: true,
      datatable_selected: [],
      datatable_headers: [{
        text: "Email",
        value: "login"
      }, {
        text: "Name",
        align: "start",
        value: "full_name"
      }, {
        text: "Company",
        value: "company_name"
      }, {
        text: "Group",
        value: "user_group",
        cellClass: "text-nowrap"
      }, {
        text: "D.Address",
        value: "delivery_address"
      }, {
        text: "Salesperson",
        value: "salesman"
      }, {
        text: "Origin",
        value: "utm_source"
      }, {
        text: "Status",
        value: "status",
        sortable: false,
        cellClass: "text-nowrap"
      }, {
        text: "Actions",
        value: "actions",
        sortable: false
      }],
      formSearch: {
        label: null,
        user_group: [],
        active: null,
        userSubscriptionStatus: null,
        include_archive: null,
        includeDeclined: null,
        salesmanId: null,
        countryIsoCodes: [],
        stateIsoCodes: [],
        city: "",
        paging: {
          limits: 24,
          currentPage: 0,
          askedPage: 0
        }
      },
      searchLabelLastUsed: null,
      searchGroupLastUsed: null,
      searchCountriesLastUsed: [],
      searchStatesLastUsed: [],
      searchCityLastUsed: null,
      dialogConfirmDelete: false,
      dialogUserId: 0,
      dialogUserFullName: "",
      errorMessages: {
        criteria: {
          format: "The criterias are incorrect"
        }
      },
      userActiveChoice: [{
        text: "Activated users",
        value: true
      }, {
        text: "Deactivated users",
        value: false
      }],
      listSalesman: [],
      listCountries: [],
      listStates: [],
      pagingLimitsChoices: defaultPagingChoices,
      isExporting: false,
      listUserGroups: listUserGroups,
      emptyCellContent: emptyCellContent,
      userSubscriptionStatus: userSubscriptionStatus,
      handlingUserSubscriptionStatus: {
        accepting: {
          isPending: false,
          cancellationToken: null
        },
        declining: {
          isPending: false,
          cancellationToken: null
        }
      }
    };
  },
  components: {
    paging: pagingComponent,
    index: indexComponent,
    confirm: confirmationComponent,
    SubscriptionInvitationModal: SubscriptionInvitationModal,
    SendInvitationAsConsultantModal: SendInvitationAsConsultantModal
  },
  computed: {
    hasResult: function hasResult() {
      return !this.datatable_loading && this.baseModel.numberOfUsers > 0;
    },
    listStatesAvailable: function listStatesAvailable() {
      var _this2 = this;
      if (this.formSearch.countryIsoCodes.length > 0) {
        var countryIds = this.listCountries.filter(function (x) {
          return _this2.formSearch.countryIsoCodes.some(function (isoCodeSelected) {
            return isoCodeSelected == x.iso_code;
          });
        }).map(function (x) {
          return x.id_country;
        });
        return this.listStates.filter(function (x) {
          return countryIds.some(function (countryId) {
            return countryId == x.id_country;
          });
        });
      } else {
        return [];
      }
    }
  },
  watch: {
    listStatesAvailable: function listStatesAvailable(newVal, oldVal) {
      if (!Object.equal(newVal, oldVal)) {
        this.formSearch.stateIsoCodes = this.formSearch.stateIsoCodes.filter(function (x) {
          return newVal.some(function (isoCodeSelected) {
            return isoCodeSelected == x.iso_code;
          });
        });
      }
    }
  },
  created: function created() {
    var _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var filters, _this, response;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _this3.loggedUserData = getLoggedUserData();
            _context2.next = 3;
            return getFilters();
          case 3:
            filters = _context2.sent;
            if (filters !== null && filters !== void 0 && filters.users) {
              _this3.formSearch = _objectSpread(_objectSpread({}, _this3.formSearch), filters.users);
            }
            _this = _this3;
            request("/v1/countries/protected?implantedMarket=true", "GET", null, true, "api").then(/*#__PURE__*/function () {
              var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(response) {
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _this.listCountries = _toConsumableArray(response.data.countries);
                      _this.listStates = _toConsumableArray(response.data.states);
                    case 2:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              return function (_x) {
                return _ref.apply(this, arguments);
              };
            }()).catch(function () {
              _this.$toasted.show("An error occured. Please contact an administrator.", {
                type: "error"
              });
            });
            if (_this3.isConsultantOrHolding(_this3.loggedUserData)) {
              getUserLogged().then(function (user) {
                _this3.currentUser = user;
              });
              _this3.datatable_headers = _this3.datatable_headers.filter(function (x) {
                return x.value != "salesman";
              });
              _this3.listUserGroups = _this3.listUserGroups.filter(function (x) {
                return x.id == "USER" || x.id == "HORECA" || x.id == "WHOLESALER";
              });
            }
            if (!isAdminNotConsultant(_this3.loggedUserData)) {
              _context2.next = 16;
              break;
            }
            _context2.next = 11;
            return request("/v1/users", "post", {
              user_group: ["ADMIN"],
              roles: [process.env.VUE_APP_ROLES_THIRD_PARTY_ORDER],
              active: true,
              isSalesman: true
            }, true, "api");
          case 11:
            response = _context2.sent;
            _this3.listSalesman = response.data.users;
            _this3.listSalesman.sort(function (a, b) {
              return b.fullname < a.fullname ? 1 : -1;
            });
            _this3.listSalesman.unshift({
              id_user: 0,
              fullname: "No salesperson attached"
            });
            if (isSalesman(_this3.loggedUserData)) {
              _this3.formSearch.salesmanId = +_this3.loggedUserData.idUser;
            }
          case 16:
            _this3.search();
          case 17:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  methods: {
    openSendInvitationAsConsultantModal: function openSendInvitationAsConsultantModal() {
      this.$refs.SendInvitationAsConsultantModal.open();
    },
    openSubscribtionInvitationModal: function openSubscribtionInvitationModal() {
      this.$refs.SubscriptionInvitationModal.open();
    },
    exportUsers: function exportUsers() {
      var _this = this;
      _this.isExporting = true;
      var filters = _objectSpread(_objectSpread({}, _this.formSearch), {}, {
        userGroup: _this.formSearch.user_group,
        includeArchive: _this.formSearch.include_archive
      });
      var paramsQuery = Object.encodeToUri(filters);
      request("/v1/users/export?params=".concat(paramsQuery), "get", null, true, "api", "blob").then(function (response) {
        _this.isExporting = false;
        fileDownload(response.data, "PLATFORM_USERS_LIST.xlsx", "application/xlsx");
      }).catch(function (_) {
        _this.isExporting = false;
        _this.$toasted.show("An error occured. Please contact an administrator.", {
          type: "error"
        });
      });
    },
    canManage: function canManage() {
      return hasRole(process.env.VUE_APP_ROLES_MANAGE_USER);
    },
    canCreateMyUsers: function canCreateMyUsers() {
      return isConsultantOrHolding(this.loggedUserData) && hasRole(process.env.VUE_APP_ROLES_MANAGE_MY_USERS);
    },
    canManageSpecificUser: function canManageSpecificUser(user) {
      return this.canManage() || isConsultantOrHolding(this.loggedUserData) && hasRole(process.env.VUE_APP_ROLES_MANAGE_MY_USERS) && !!user.active;
    },
    canEditRoles: function canEditRoles() {
      return hasRole(process.env.VUE_APP_ROLES_MANAGE_USER_ROLES);
    },
    goToAdd: function goToAdd() {
      return {
        name: "adminUserDetails"
      };
    },
    goToUserPage: function goToUserPage(user) {
      return {
        name: "adminUserDetails",
        query: {
          id_user: user.id_user,
          fromList: true
        }
      };
    },
    goToUserRoles: function goToUserRoles(user) {
      return {
        name: "adminUserRoles",
        params: {
          fullname: getFullNameUser(user)
        },
        query: {
          id_user: user.id_user
        }
      };
    },
    setActiveUser: function () {
      var _setActiveUser = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(user, active) {
        var confirmed, _this, data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.$refs.confirm.open("".concat(active ? "ACTIVATE USER" : "DEACTIVATE USER"), "Are you sure you want to <span class=\"text-bold\">".concat(active ? "activate" : "deactivate", "</span> the user : <br> ").concat(user.login, ", WITH notification.\n          <br> <p style='color: red'>This will alert the user <span class='text-bold'>WITH</span> an email notification.</p>"), {
                isHtmlMessage: true,
                width: 400
              });
            case 2:
              confirmed = _context3.sent;
              if (confirmed) {
                _context3.next = 5;
                break;
              }
              return _context3.abrupt("return");
            case 5:
              document.body.style.cursor = "wait";
              _this = this;
              data = {
                IdUser: user.id_user,
                Active: active,
                WithNotification: true
              };
              request("/v1/user/active", "put", data, true, "api").then(function (response) {
                _this.$toasted.show("User " + user.fullname + " has been succesfully " + (active ? "activated" : "deactivated") + ".", {
                  type: "success"
                });
                _this.search();
                document.body.style.cursor = "default";
              }).catch(function (err) {
                _this.$toasted.show("An error occured. Please contact an administrator.", {
                  type: "error"
                });
                document.body.style.cursor = "default";
              });
            case 9:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function setActiveUser(_x2, _x3) {
        return _setActiveUser.apply(this, arguments);
      }
      return setActiveUser;
    }(),
    setArchiveUser: function setArchiveUser(user, archive) {
      document.body.style.cursor = "wait";
      var _this = this;
      var data = {
        id_user: user.id_user,
        archive: archive
      };
      request("/v1/user/archive", "put", data, true, "api").then(function (response) {
        _this.$toasted.show("User " + user.fullname + " has been succesfully " + (archive ? "archived" : "unarchived") + ".", {
          type: "success"
        });
        _this.search();
        document.body.style.cursor = "default";
      }).catch(function (_) {
        _this.$toasted.show("An error occured. Please contact an administrator.", {
          type: "error"
        });
        document.body.style.cursor = "default";
      });
    },
    deleteUser: function deleteUser(user) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var confirmed, _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this4.$refs.confirm.open("Deletion", "Are you sure you want to definetely delete the user " + user.fullname + " ?", {
                color: "red"
              });
            case 2:
              confirmed = _context4.sent;
              if (confirmed) {
                _this4.$EventBus.$emit("loading", true);
                _this = _this4;
                request("/v1/user/" + user.id_user, "delete", null, true, "api").then(function (res) {
                  _this.$toasted.show("User " + user.fullname + " deleted.", {
                    type: "success"
                  });
                  _this.search();
                }).catch(function (err) {
                  _this.$toasted.show("An error occured. Please contact an administrator.", {
                    type: "error"
                  });
                }).finally(function (_) {
                  _this4.$EventBus.$emit("loading", false);
                });
              }
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    acceptUserSubscription: function acceptUserSubscription(withNotif, user) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this5$handlingUserSu;
        var confirmed, _this, data, currentUser;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this5.$refs.confirm.open("Accept user subscription", "Are you sure you want to accept this user's subscription, ".concat(withNotif ? "WITH email notification" : "WITHOUT email notification", "  ").concat(withNotif ? "<br><br> <p style='color: green'>This will notify the user <span class='text-bold'>WITH</span> an email notification.</p>" : "<br><br> <p style='color: red'>This <span class='text-bold'>WILL NOT</span> notify the user by email.</p>"), {
                isHtmlMessage: true,
                width: 400
              });
            case 2:
              confirmed = _context6.sent;
              if (confirmed) {
                _context6.next = 5;
                break;
              }
              return _context6.abrupt("return");
            case 5:
              _this5.$EventBus.$emit("loading", true);
              _this5.handlingUserSubscriptionStatus.accepting.isPending = true;
              (_this5$handlingUserSu = _this5.handlingUserSubscriptionStatus.accepting.cancellationToken) === null || _this5$handlingUserSu === void 0 || _this5$handlingUserSu.cancel();
              _this5.handlingUserSubscriptionStatus.accepting.cancellationToken = axios.CancelToken.source();
              _this = _this5;
              data = {
                IdUser: user.id_user,
                Status: userSubscriptionStatus.ACCEPTED.id,
                WithNotification: withNotif
              };
              _context6.next = 13;
              return request("/v1/subscribe/status", "put", data, true, "api", null, _this.handlingUserSubscriptionStatus.accepting.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                    while (1) switch (_context5.prev = _context5.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.handlingUserSubscriptionStatus.accepting.isPending = false;
                          _this.c.accepting.cancellationToken = null;
                          _this5.$EventBus.$emit("loading", false);
                          errorData = getErrorData(e, {}, "Unable to approve user subscription.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context5.stop();
                    }
                  }, _callee5);
                }));
                return function (_x4) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 13:
              currentUser = _this5.baseModel.users.find(function (x) {
                return x.id_user == user.id_user;
              });
              if (currentUser) {
                currentUser.active = true;
                currentUser.subscriptionStatus = userSubscriptionStatus.ACCEPTED.id;
                currentUser.isSubscriptionPendingActivation = false;
              }
              _this5.handlingUserSubscriptionStatus.accepting.isPending = false;
              _this5.handlingUserSubscriptionStatus.accepting.cancellationToken = null;
              _this5.$EventBus.$emit("loading", false);
              _this5.$toasted.show("User subscription accept.", {
                type: "success"
              });
            case 19:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    declineUserSubscription: function declineUserSubscription(withNotif, user) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this6$handlingUserSu;
        var confirmed, _this, data, currentUser;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _this6.$refs.confirm.open("Decline user subscription", "Are you sure you want to decline this user's subscription, ".concat(withNotif ? "WITH email notification" : "WITHOUT email notification", "  ").concat(withNotif ? "<br><br> <p style='color: green'>This will alert the user <span class='text-bold'>WITH</span> an email notification.</p>" : "<br><br> <p style='color: red'>This <span class='text-bold'>WILL NOT</span> notify the user by email.</p>"), {
                isHtmlMessage: true,
                width: 400
              });
            case 2:
              confirmed = _context8.sent;
              if (confirmed) {
                _context8.next = 5;
                break;
              }
              return _context8.abrupt("return");
            case 5:
              _this6.$EventBus.$emit("loading", true);
              _this6.handlingUserSubscriptionStatus.declining.isPending = true;
              (_this6$handlingUserSu = _this6.handlingUserSubscriptionStatus.declining.cancellationToken) === null || _this6$handlingUserSu === void 0 || _this6$handlingUserSu.cancel();
              _this6.handlingUserSubscriptionStatus.declining.cancellationToken = axios.CancelToken.source();
              _this = _this6;
              data = {
                IdUser: user.id_user,
                Status: userSubscriptionStatus.DECLINED.id,
                WithNotification: withNotif
              };
              _context8.next = 13;
              return request("/v1/subscribe/status", "put", data, true, "api", null, _this.handlingUserSubscriptionStatus.declining.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.handlingUserSubscriptionStatus.declining.isPending = false;
                          _this.handlingUserSubscriptionStatus.declining.cancellationToken = null;
                          _this6.$EventBus.$emit("loading", false);
                          errorData = getErrorData(e, {}, "Unable to decline user subscription.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7);
                }));
                return function (_x5) {
                  return _ref3.apply(this, arguments);
                };
              }());
            case 13:
              currentUser = _this6.baseModel.users.find(function (x) {
                return x.id_user == user.id_user;
              });
              if (currentUser) {
                currentUser.active = false;
                currentUser.subscriptionStatus = userSubscriptionStatus.DECLINED.id;
                currentUser.isSubscriptionPendingActivation = false;
              }
              _this6.handlingUserSubscriptionStatus.declining.isPending = false;
              _this6.handlingUserSubscriptionStatus.declining.cancellationToken = null;
              _this6.$EventBus.$emit("loading", false);
              _this6.$toasted.show("User subscription declined.", {
                type: "success"
              });
            case 19:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    changePage: function changePage(askedPage) {
      if (askedPage >= 0 && askedPage <= this.baseModel.numberOfPages) {
        this.formSearch.paging.askedPage = askedPage;
        this.search();
      }
    },
    resetPaging: function resetPaging() {
      this.formSearch.paging.askedPage = 0;
    },
    search: function search() {
      var _this7 = this;
      var isResetPaging = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.$EventBus.$emit("loading", true);
      var _this = this;
      if (isResetPaging) _this.resetPaging();
      setFilters(function (state) {
        return _objectSpread(_objectSpread({}, state), {}, {
          users: _this7.formSearch
        });
      });
      document.body.style.cursor = "wait";
      _this.datatable_loading = true;

      //Handling no values for fields
      if (_this.formSearch.active == "null") {
        _this.formSearch.active = null;
      }
      if (_this.formSearch.salesmanId == "null") {
        _this.formSearch.salesmanId = null;
      }
      _this.searchLabelLastUsed = _this.formSearch.label;
      _this.searchGroupLastUsed = _this.formSearch.user_group;
      _this.searchCountriesLastUsed = _this.formSearch.countryIsoCodes;
      _this.searchStatesLastUsed = _this.formSearch.stateIsoCodes;
      _this.searchCityLastUsed = _this.formSearch.city;
      request("/v1/users", "post", _this.formSearch, true, "api").then(function (response) {
        _this.datatable_loading = false;
        _this.baseModel = {
          users: _toConsumableArray(response.data.users),
          numberOfUsers: response.data.total_number,
          numberOfPages: Math.ceil(response.data.total_number / _this.formSearch.paging.limits)
        };
        _this.formSearch.paging.currentPage = _this.formSearch.paging.askedPage + 1;
        if (!_this.formSearch.paging.currentPage) {
          _this.formSearch.paging.currentPage = 0;
        }
        document.body.style.cursor = "default";
        _this.$EventBus.$emit("loading", false);
      }).catch(function (err) {
        _this.$toasted.show("An error occured. Please contact an administrator.", {
          type: "error"
        });
        document.body.style.cursor = "default";
        _this.datatable_loading = false;
        _this.$EventBus.$emit("loading", false);
      });
    },
    computeDeliveryAddress: function computeDeliveryAddress(user) {
      var strings = [];
      if (user.deliveryCountryName) strings.push(user.deliveryCountryName);
      if (user.deliveryStateIsoCode) strings.push(user.deliveryStateIsoCode);
      if (user.deliveryCity) strings.push(user.deliveryCity);
      return strings.length > 0 ? strings.join(", ") : emptyCellContent;
    },
    isUserSubscriptionDeclined: function isUserSubscriptionDeclined(user) {
      return user.subscriptionStatus === this.userSubscriptionStatus.DECLINED.id && !user.active;
    },
    isConsultantOrHolding: isConsultantOrHolding,
    isHolding: isHolding,
    isAdminNotConsultant: isAdminNotConsultant,
    getFullNameUser: getFullNameUser,
    filterVAutocomplete: filterVAutocomplete
  }
};